
import { GameRole } from '../../types/game';
import { skills } from '../skills';
import { challenges } from '../challenges';

export const entrepreneurRole: GameRole = {
  id: 'entrepreneur',
  title: 'Mining Entrepreneur',
  description: 'Build your own mining operation from the ground up. Secure funding, acquire equipment, and scale your business while navigating market volatility.',
  difficulty: 'Expert',
  strengths: [
    'Best profit margin potential',
    'Most flexible career path',
    'Highest long-term rewards'
  ],
  startingSkills: [
    skills.find(s => s.id === 'financial-planning')!
  ],
  careerPath: [
    {
      level: 'Junior',
      title: 'Mining Entrepreneur',
      requiredExperience: 0,
      requiredYears: 0
    },
    {
      level: 'Mid-Level',
      title: 'Mining Business Owner',
      requiredExperience: 150,
      requiredYears: 3
    },
    {
      level: 'Senior',
      title: 'Mining Corporation CEO',
      requiredExperience: 350,
      requiredYears: 6
    },
    {
      level: 'Leader',
      title: 'Mining Industry Magnate',
      requiredExperience: 700,
      requiredYears: 10
    }
  ],
  specialChallenges: [
    challenges.find(c => c.id === 'bitcoin-halving')!,
    challenges.find(c => c.id === 'market-volatility')!,
    challenges.find(c => c.id === 'expansion-opportunity')!
  ],
  careerObjectives: [
    {
      title: 'Growth Master',
      description: 'Scale from 50 to 500 miners profitably',
      target: {
        kpi: 'profitMargin',
        value: 25
      },
      reward: 'Business Visionary Badge'
    },
    {
      title: 'Market Disruptor',
      description: 'Achieve industry-leading profit margins',
      target: {
        kpi: 'profitMargin',
        value: 35
      },
      reward: 'Industry Titan Badge'
    }
  ]
};
